import { formatRenewalDate } from "shared/utils/formatDate";

/** yyyy-MM-dd → "Jan 1, 2027" without shifting the calendar day across timezones. */
export const formatTestDate = (ymd?: string | null) =>
  ymd ? formatRenewalDate(new Date(`${ymd}T12:00:00Z`), "MMM d, yyyy") : "";
